import React, { useState } from 'react'

const CustomValuesHookTS = <T,>(props: T): [T, (e: T) => void] => {
    const [localStates, setLocalStates] = useState<T>({ ...props } as T);
    const handleChange = (e: T) => {
        for (let prop in e) {
            setLocalStates((state) => ({
                ...state,
                [prop]: e[prop]
            }))
        }

    }

    return [localStates, handleChange]
}

export default CustomValuesHookTS